/**
 * Legenda rolurilor + cum funcționează o invitație. Afișată lângă formularul
 * de invitare, ca cel care invită să știe ce acordă.
 */
import { useTranslation } from 'react-i18next';

const ROLES = ['owner', 'admin', 'member', 'viewer'] as const;
const STEPS = ['how_1', 'how_2', 'how_3', 'how_4'] as const;

export default function RoleLegend() {
  const { t } = useTranslation();
  return (
    <div className="grid gap-4 sm:grid-cols-2 text-xs text-[var(--text-muted)]">
      <div>
        <h3 className="section-label no-dot mb-2">{t('tenant_invites.legend_title')}</h3>
        <dl className="space-y-2">
          {ROLES.map((role) => (
            <div key={role}>
              <dt>
                <span className="badge bg-[var(--bg-surface)] text-[var(--text)] text-[10px]">
                  {role}
                </span>
              </dt>
              <dd className="mt-0.5">{t(`tenant_invites.role_${role}`)}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-2 text-[10px] text-[var(--text-dim)]">{t('tenant_invites.owner_note')}</p>
      </div>
      <div>
        <h3 className="section-label no-dot mb-2">{t('tenant_invites.how_title')}</h3>
        <ol className="space-y-2 list-decimal pl-4">
          {STEPS.map((step) => (
            <li key={step}>{t(`tenant_invites.${step}`)}</li>
          ))}
        </ol>
      </div>
    </div>
  );
}
